import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { getLoggedInUser } from 'helpers/fakebackend_helper'
//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';
import axios from 'axios';

const ProfileDropdown = () => {

    const profiledropdownData = createSelector(
        (state: any) => state.Profile,
        (user) => user.user
    );
    
    //const user = useSelector(profiledropdownData);

    const [userName, setUserName] = useState("Admin");


    const [userInfo, setUserInfo] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);


    const user = getLoggedInUser();




  
    //const fetchUserInfo = async () => {
    //  try {
  
    //    const authUser: any = localStorage.getItem("authUser");
    //    const token = authUser ? JSON.parse(authUser).token : null;
  
    //    if (!token) {
    //      console.error("No authentication token found.");
    //      setError("No authentication token found.");
    //      setLoading(false);
    //      return;
    //    }
  
    //    const requestData = { action: "myextension" };
  
    //    const response = await axios.post("/api/", requestData, {
    //      headers: {
    //        "Content-Type": "application/json",
    //        "Authorization": `Bearer ${token}`, 
    //        "Accept": "application/json",
    //      },
    //      withCredentials: true,
    //    });
  
        
    //    if (response) {
         
    //      setUserInfo(response);  
    //      setLoading(false);
    //    } else {
    //      setError("No data returned from API.");
    //      setLoading(false);
    //    }
    //  } catch (error) {
    //    console.error("❌ API Error:", error);
    //    setError("Error fetching user information.");
    //    setLoading(false);
    //  }
    //};
  
    //useEffect(() => {
    //  fetchUserInfo();
    //}, []); 
    //const handleToggle = (key: string) => {
    //  setUserInfo((prevState: any) => ({
    //    ...prevState,
    //    [key]: {
    //      ...prevState[key],
    //      enable: prevState[key]?.enable === "on" ? "off" : "on",
    //    },
    //  }));
    //};
  


    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        {user?.userinfo?.firstname || user?.userinfo?.lastname ? (
                            <div
                                className="avatar-md rounded-circle img-thumbnail d-flex align-items-center justify-content-center"
                                style={{ backgroundColor: "white", width: "48px", height: "48px" }}
                            >
                                <span>
                                    {/* First and Lastname initials */}
                                    {user.userinfo.firstname?.substring(0, 1).toUpperCase()}
                                    {user.userinfo.lastname?.substring(0, 1).toUpperCase()}
                                </span>
                            </div>
                        ) : (
                            <div className="avatar-md rounded-circle img-thumbnail d-flex align-items-center justify-content-center" style={{ backgroundColor: "white", width: "48px", height: "48px" }}>
                                <span>NA</span> 
                            </div>
                        )}

                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text"> {user.userinfo.firstname} {user.userinfo.lastname}
                            </span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text"> </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Bienvenue {user.userinfo.firstname}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/profile" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    {/*<DropdownItem className='p-0'>*/}
                    {/*    <Link to="/apps-chat" className="dropdown-item">*/}
                    {/*        <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span*/}
                    {/*            className="align-middle">Messages</span>*/}
                    {/*    </Link>*/}
            
                    {/*</DropdownItem>*/}
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;